import { prefixObjectValues } from '../utils';

const contractTerms = {
  bonusesTxt: 'bonuses-incentives',
  adminCostsTxt: 'administrative-costs',
  infrastructureTxt: 'infrastructure-requirements',
  extraTxt: 'other-terms',
};

export default prefixObjectValues(contractTerms, 'listing-search-contract-terms');
